function getReadingTime() {
    const textContainer = document.querySelector<HTMLElement>('[data-reading-count]');
    const readTimeContainer = document.querySelector<HTMLElement>('[data-reading-time]');
    const readingTime = (): string => {
        if (textContainer && textContainer.innerHTML !== '') {
            const textContent = textContainer.innerHTML;
            const WORDSPERMINUTE = 200;
            const wordNum = textContent.split(/\s/g).length;
            const minutes = wordNum / WORDSPERMINUTE;
            const time = Math.ceil(minutes);
            return `${time}`;
        }
        return '1.5';
    };
    const init = () => {
        if (textContainer && readTimeContainer) {
            const readingTimeTag = readTimeContainer.querySelector(
                '[data-reading-number]'
            );
            if (readingTimeTag !== null) {
                readingTimeTag.innerHTML = readingTime();
                readTimeContainer.style.opacity = '1';
            }
        }
    };
    return {
        init: init,
    };
}

export default getReadingTime;
